<template>
    <div class="footer d-flex py-5 justify-content-around flex-wrap">
        <FooterItem :header="$t('vfair.footerHeaders.social')">
            <div class="d-flex justify-content-between sociallinks">
                <a href="https://www.facebook.com/HigheredGlobal/" target="_blank"
                    ><img :src="facebookLogo" class="footersociallogo" alt=""
                /></a>
                <a href="https://twitter.com/Highered_org" target="_blank"
                    ><img :src="twitterLogo" class="footersociallogo" alt=""
                /></a>
                <a href="https://www.instagram.com/gethighered" target="_blank"
                    ><img :src="instagramLogo" class="footersociallogo" alt=""
                /></a>
                <a href="https://www.linkedin.com/showcase/65424950" target="_blank"
                    ><img :src="linkedInLogo" class="footersociallogo" alt=""
                /></a>
                <a href="https://www.youtube.com/channel/UC0phZTUG7Q8BRJMPZL74Ihg" target="_blank"
                    ><img :src="youTubeLogo" class="footersociallogo" alt=""
                /></a>
            </div>
        </FooterItem>
        <!-- <FooterItem :header="$t('vfair.footerHeaders.sponsored')">
            <img :src="abInbevLogo" class="footerlogo" alt="" />
        </FooterItem> -->
        <FooterItem :header="$t('vfair.footerHeaders.organized')">
            <img :src="higheredLogo" class="footerlogo" alt="" />
        </FooterItem>
    </div>
</template>

<script>
import FooterItem from './FooterItem';
import HigheredLogo from '../../../assets/img/vcf/HigheredEFMD.png';
import FacebookLogo from '../../../assets/img/Facebook.png';
import TwitterLogo from '../../../assets/img/Twitter.png';
import YouTubeLogo from '../../../assets/img/YouTube.png';
import LinkedInLogo from '../../../assets/img/LinkedIn.png';
import InstagramLogo from '../../../assets/img/Instagram.png';
export default {
    name: 'Footer',
    components: {
        FooterItem,
    },
    data: () => {
        return {
            higheredLogo: HigheredLogo,
            facebookLogo: FacebookLogo,
            twitterLogo: TwitterLogo,
            youTubeLogo: YouTubeLogo,
            linkedInLogo: LinkedInLogo,
            instagramLogo: InstagramLogo,
        };
    },
};
</script>

<style>
.footer {
    background: #fff;
}
.footerlogo {
    width: 200px;
}
.footersociallogo {
    width: 40px;
}
.sociallinks {
    width: 230px;
}
</style>
